import { get, set } from 'lodash';

import { FIELD_PATHS } from '@funnels/constants';
import { Company, FormValuesEmployment, Income, StoreEmployment } from '@funnels/types';

export function removeUnlinkedCompaniesAndIncomes(values: FormValuesEmployment) {
  const employments: StoreEmployment[] = get(values, FIELD_PATHS.EMPLOYMENTS(), []);
  const companies: Company[] = get(values, FIELD_PATHS.COMPANIES(), []);
  const incomes: Income[] = get(values, FIELD_PATHS.INCOMES(), []);
  const companyIdsToBeRemoved: string[] = [];
  companies.forEach((company) => {
    const companyclientId = get({ companies: [company] }, FIELD_PATHS.COMPANY_CLIENT_ID(0));
    if (
      !employments.some(
        (employment) =>
          get({ employments: [employment] }, FIELD_PATHS.EMPLOYMENT_COMPANY_CLIENT_ID(0)) === companyclientId
      )
    ) {
      companyIdsToBeRemoved.push(companyclientId);
    }
  });
  set(
    values,
    FIELD_PATHS.COMPANIES(),
    companies.filter(
      (company) => !companyIdsToBeRemoved.includes(get({ companies: [company] }, FIELD_PATHS.COMPANY_CLIENT_ID(0)))
    )
  );
  set(
    values,
    FIELD_PATHS.INCOMES(),
    incomes.filter(
      (income) => !companyIdsToBeRemoved.includes(get({ incomes: [income] }, FIELD_PATHS.INCOME_COMPANY_CLIENT_ID(0)))
    )
  );
}
